// extracted by mini-css-extract-plugin
module.exports = {"author":"author_author__4DUdg","avatar":"author_avatar__OPsAM","secondary":"author_secondary__n1_ce"};